import { ActionTree } from "vuex";
import { ControllerState, Controller } from "./model";
import { RootStateType } from "@/store";
import { AxiosResponse } from "axios";
import Qs from "qs";

export const buildParamHash = (params: any) => ({
  params: params,
  paramsSerializer: function (params: object) {
    return Qs.stringify(params, { arrayFormat: 'brackets' })
  }
});

const actions: ActionTree<ControllerState, RootStateType> = {
  findList({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].get('/controllers', buildParamHash(params))
      .then((response: AxiosResponse) => {
        const controllers: Controller[] = response.data;
        commit('setControllers', controllers)
        return controllers
      })
  },
  find({ rootGetters, commit }, id) {
    return rootGetters['hcs/client'].get(`/controllers/${id}`)
      .then((response: AxiosResponse) => {
        const controller: Controller = response.data;
        commit('setController', controller)
        return controller
      })
  },
  create({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].post('/controllers', params)
      .then((response: AxiosResponse) => {
        const controller: Controller = response.data;
        commit('addController', controller)
        return controller
      })
  },
  update({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].patch(`/controllers/${params.id}`, params)
      .then((response: AxiosResponse) => {
        const controller: Controller = response.data;
        commit(('updateController'), controller)
        return controller
      })
  },
  delete({ rootGetters, commit }, id) {
    return rootGetters['hcs/client'].delete(`/controllers/${id}`)
      .then((response: AxiosResponse) => {
        commit(('deleteController'), id)
      })
  },
  fetchDownloadCredential({ rootGetters }, id) {
    return rootGetters['hcs/client'].get(`/controllers/${id}/download_credential`, { responseType:'blob' })
      .then((response: AxiosResponse) => {
        const credentialData = new Blob([response.data], {
          type: response.data.type
        });
        return credentialData
      })
  }
}

export default actions;
